import _ from 'lodash'
import {getter} from 'util/BackboneCompatUtil';
import {castToSisTypePrimitive} from 'util/SisType';
import {DqParamTO, SisType} from 'generated/JavaTO'
import {CFModel, isCFMemberNull} from 'module/CustomField/type/CFType'

function getDqParamFromModel(dqParam: DqParamTO, model: CFModel) {
	if (!dqParam) return;
	let {srcName, startIndex, length, type, defaultValue} = dqParam;
	let ret;
	if (_.startsWith(srcName, 'cf.')) {
		const cf = getter(model, 'cf');
		let cfDstField = srcName.substr(3).split(/[[.]/, 1)[0];
		let remainingDstField = srcName.substr(3 + cfDstField.length);
		if (_.startsWith(remainingDstField, '.')) remainingDstField = remainingDstField.substr(1);
		const cfMembers = _.sortBy(_.filter(cf, c => c.dstField === cfDstField && !isCFMemberNull(c)), 'pos');
		ret = _.get(cfMembers, remainingDstField);
		if (!ret && ret !== 0) ret = '';
	} else {
		ret = getter(model, srcName);
		if (!ret && ret !== 0) ret = '';
		ret += '';
		ret = ret.substr(startIndex, length);
	}
	if (!ret && ret !== 0) {
		if (defaultValue != null) return castToSisTypePrimitive(defaultValue, type as SisType);
		return null
	} else {
		return castToSisTypePrimitive(ret, type as SisType);
	}
}

export function getDqParamsObject(dqParams: DqParamTO[], model: any): Record<string, any> {
	if (!dqParams || !model) return {};
	const ret: Record<string, any> = {}
	dqParams.forEach(p => {
		ret[p.dstName] = getDqParamFromModel(p, model);
	});
	return ret;
}


export function parseDqParamFromSerializedString(str: string): DqParamTO {
	const x = str.split('|')
	return {
		srcName: x[0],
		dstName: x[1],
		startIndex: parseInt(x[2]) || 0,
		length: parseInt(x[3]) || undefined,
		type: x[4] || ' ',
		defaultValue: x[5] || null,
	}
}